<template>
	<div class="header-template">
		<div class="header-box">
			<div class="header">
				<div class="logo-box" @click="logo_box()">
					<img class="logo-img" src="../../assets/logo/TOZO_logo_move.png" alt="TOZO Official logo"/>
					<!-- <img :src="logoUrl"/> -->
				</div>
				<div class="right-box">
					<div class="iconBox" @click.stop="check_search()">
					 	<i class="el-icon-search"></i>
					</div>
					<div class="iconBox" @click.stop="check_menu()">
					 	<i class="el-icon-menu"></i>
					</div>
					<div class="iconBox" @click.stop="check_information()">
					 	<i v-if="!open_a_menu" class="el-icon-s-unfold"></i>
					 	<i v-else class="el-icon-close"></i>
					</div>
				</div>
			</div>
			
			<div class="product-menu-box" :class="open_a_menu ? 'open_a_menu' : 'hidde_a_menu'">
				<MenuMove @close_menu="close_menu"></MenuMove>
			</div>
			<div class="bulletFrame-box" :class="open_bulletFrame ? 'open_bulletFrame' : 'hidde_bulletFrame'">
				<bulletFrame :TypeName="TypeName" @close_bulletFrame="close_bulletFrame"></bulletFrame>
			</div>
		</div>
		
	</div>
</template>

<script>
import MenuMove from './MenuMove.vue'
import bulletFrame from './bulletFrame.vue';
import SearchUser from '../SearchUser.vue';

export default {
	name: 'header-nav-move',
	components: { MenuMove, bulletFrame },

	// props: {
	// 	Post_List: {
	// 		type: Array,
	// 		default: []
	// 	},
	// },
	data() {
		return {
			pop_up: "",
			open_a_menu: false,
			open_bulletFrame: false,
			TypeName: "",
			logoUrl: "https://www.tozostore.com/cdn/shop/files/tozo_logo_m_1600x.png?v=1720407847",
		}
	},
	
	// 监听
	watch: {
		// "Post_List": {
		// 	handler: function (newValue, oldValue) {
		// 		this.list = this.Post_List
		// 	},
		// 	deep: true
		// },
	},
	
	// beforeCreate() {
		
	// }
	
  created () {
	  
  },
  
  mounted() {
	  // this.list = this.Post_List
  },
  
  methods:{
	//查看 粉丝或关注人信息
	check_information(item){
		this.open_bulletFrame = false
		this.open_a_menu =! this.open_a_menu
	},
	
	//查看 搜索
	check_search(item){
		this.open_a_menu = false
		this.open_bulletFrame = true
		this.TypeName = "search-user"
		// this.open_a_menu =! this.open_a_menu
		// this.$router.push({
		//   name: "search-user",
		//   // params: {
		//   //   routeName: 'add' + '_' + '添加产品基本信息',
		//   //   page: this.listQuery.page,
		//   // }
		// })
	},
	
	//查看 粉丝或关注人信息
	check_menu(item){
		this.open_a_menu = false
		this.open_bulletFrame = true
		this.TypeName = "sidebar"
		// this.open_a_menu =! this.open_a_menu
		// this.$router.push({
		//   name: "Sidebar",
		//   // params: {
		//   //   routeName: 'add' + '_' + '添加产品基本信息',
		//   //   page: this.listQuery.page,
		//   // }
		// })
	},
	
	close_bulletFrame(){
		this.open_bulletFrame = false
	},
	
	logo_box(){
		let language = this.$language == "" || this.$language == "en" ? "" : `/${this.$language}`
		console.log(language)
		window.open(`https://www.tozostore.com${language}`, '_blank')
	},
	
	//关闭菜单
	close_menu(){
		this.open_a_menu = false
		this.open_bulletFrame = false
	},
	
  }
}
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
	}
	.header-template{
		width: 100%;
		display: flex;
		justify-content: center;
		padding: 0%;
	}
	.header-box{
		width: 100%;
		position: relative;
	}
	.header{
		position: sticky;
		top: 0;
		z-index: 9999;
		padding: 5px 10px;
		width: 100%;
		min-height: 50px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: #000000;
	}
	.logo-box{
		max-width: 100px;
		cursor: pointer;
		display: flex;
		align-items: center;
	}
	.logo-img{
		max-width: 120px;
		width: 100%;
	}
	.product-menu-box{
		margin-top: 0;
		width: 100%;
		position: absolute;
		top: 50px;
		transition: left 0.5s;
	}
	.open_a_menu{
		left: 0;
	}
	.hidde_a_menu{
		left: -110vw;
	}
	.right-box{
		display: flex;
		.iconBox{
			height: 40px;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			cursor: pointer;
			font-size: 24px;
			color: #ffffff;
			&:last-child{
				margin-right: 0px;
			}
			i{
				
			}
			
		}
	}
	.bulletFrame-box{
		margin-top: 0;
		width: 100%;
		position: absolute;
		left: 0;
		transition: top 0.5s;
	}
	.open_bulletFrame{
		top: 50px;
	}
	.hidde_bulletFrame{
		top: -100vh;
	}
	@media screen and (max-width: 1024px) and (min-width: 768px){
	  .iconBox{
			margin-right: 15px;
		}
	}
	@media screen and (max-width: 768px){
	  .iconBox{
			margin-right: 10px;
		}
	}
</style>
